import React from 'react';
import { Game } from '../types';
import GameBoard from './GameBoard';

interface GameReviewProps {
  game?: Game | null;
}

const GameReview: React.FC<GameReviewProps> = ({ game }) => {
  if (!game) {
    return (
      <div className="panel">
        <h3>Review</h3>
        <p className="app-subtitle">Select a completed game to review your guesses.</p>
      </div>
    );
  }

  return (
    <div className="panel">
      <h3>Review</h3>
      <p className="app-subtitle">
        {game.status === 'active' ? 'Game in progress' : `Target word: ${game.target_word}`}
      </p>
      <GameBoard guesses={game.guesses} maxGuesses={6} reveal={false} />
      <div style={{ marginTop: 16 }}>
        {game.guesses.map((guess, idx) => (
          <div key={`${guess.guessed_at}-${idx}`} style={{ marginBottom: 12 }}>
            <strong>{guess.guess.toUpperCase()}</strong>
            {guess.definition?.definition && (
              <div style={{ color: 'var(--theme-muted)' }}>{guess.definition.definition}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default GameReview;
